import { capitalize } from '@mui/material';

import { TableData, TableRow } from '@Components/Table';
import { CommonConstants } from '@Constants/index';
import { UsersItems } from '@Models/users.models';

/**
 * Takes the passed parameters
 *
 * Returns data for table row in desired format.
 */
export const createData = (
  accountId: number,
  email: string,
  firstName: string,
  lastName: string,
  admin?: boolean,
  actions?: React.ReactNode
): TableData => ({
  accountId,
  userName: `${capitalize(firstName)} ${capitalize(lastName)}`,
  userType: admin
    ? capitalize(CommonConstants.USER_ROLES.ADMIN)
    : capitalize(CommonConstants.USER_ROLES.USER),
  email,
  actions,
});

/**
 * Returns Rows and Total Rows Count for Table Component.
 */
export const getRows = (
  items: UsersItems[] = [],
  actions: (
    id: string,
    name: string,
    hasTpr: boolean,
    hasLiveConnectSuite: boolean,
    admin: boolean
  ) => JSX.Element
): TableRow[] => {
  const rows: TableRow[] = items.map((data) => ({
    id: `${data.accountId}`,
    data: createData(
      data.accountId,
      data.email,
      data.firstName,
      data.lastName,
      data.admin,
      actions(
        `${data.accountId}`,
        `${data.firstName} ${data.lastName}`,
        data.hasTpr,
        data.hasLiveConnectSuite,
        data.admin
      )
    ),
  }));

  return rows;
};
